var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export default (function (fetchImplementation) {
    return function forAuctionGraph(_a, opts) {
        var query = _a.query, variables = _a.variables, operationName = _a.operationName;
        var body = { query: query, variables: variables, operationName: operationName };
        var passthroughOpts = opts || {};
        var _b = passthroughOpts.headers, headers = _b === void 0 ? {} : _b, requestTimeout = passthroughOpts.requestTimeout;
        if (requestTimeout) {
            headers['Auction-Graph-Duration-Budget'] = requestTimeout;
        }
        return fetchImplementation
            .fromService('RESI_GRAPH_API_URL')
            .post('/graphql', __assign(__assign({}, (passthroughOpts || {})), { useProxy: false, credentials: 'include', requestTimeout: requestTimeout,
            headers: headers,
            body: body }));
    };
});
//# sourceMappingURL=graph.js.map